import type { IAuctionBet } from '../../../../repositories/billing-tariffs/entities/PublishTerms/AuctionBet';
import { IPromotionState } from '../../../../reducers/v2';
import { defaultState } from '../../../../reducers/v2/promotion/defaultState';
import { defaultTo } from 'ramda';

export function mapAuctionBet(auction: IAuctionBet | null): IPromotionState['auctionBet'] {
  if (!auction) {
    return defaultState.auctionBet;
  }

  return {
    token: auction.token,
    step: auction.step,
    maxBet: defaultTo(defaultState.auctionBet.maxBet, auction.maximalBet),
    minBet: defaultTo(defaultState.auctionBet.minBet, auction.minimalBet),
    available: auction.isAvailable,
    restrictionType: auction.restrictionType,
    value: auction.bet,
    previousBets: [],
    nextBets: [],
  };
}
